module.exports = __webpack_public_path__ + "img/16531bf.svg";